export default __webpack_public_path__ + "static/media/mobile-no-selected.3d863974.svg";